import React, { useContext, useEffect, useState } from 'react'
// import ReactModal from 'react-modal'

import Cards from '../Cards/Cards'

import EquipSelect from './subComponents/EquipSelect'
import EquipmentModal from './subComponents/EquipmentModal'

import './equipementTabModal.scss'
// import language from '../../data/language.json'
// import CardSelect from './subComponents/CardSelect'
// import EnchantSelect from './subComponents/EnchantSelect'

import { CharacterContext } from '../../contexts/character'
import { DBContext } from '../../contexts/databases'

import * as jobsID from '../../data/jobID'

// import itemInfo from '../../data/Items/itemInfo.json'
// import idnum2itemresnametable from '../../data/Items/idnum2itemresnametable.json'
// import num2cardillustnametable from '../../data/Items/num2cardillustnametable.json'

function EquipementTabModal(props) {
	const { job, changeEquipSets, inventory, maxRefine } =
		useContext(CharacterContext)
	const { item_db_equip, item_combos } = useContext(DBContext)
	const [equip, setEquip] = useState([])
	const [shadowEquip, setShadowEquip] = useState([])
	// const [isShadowGear, setIsShadowGear] = useState(false)
	const [currentLocation, setCurrentLocation] = useState('Head_Top')
	// console.log(maxRefine)
	// const locationList = [
	// 	'Head_Top',
	// 	'Head_Mid',
	// 	'Head_Low',
	// 	'Armor',
	// 	'Right_Hand',
	// 	'Left_Hand',
	// 	'Garment',
	// 	'Shoes',
	// 	'Right_Accessory',
	// 	'Left_Accessory',
	// ]
	// const locationSlotList = [
	// 	'headUpperItem',
	// 	'headMiddleItem',
	// 	'headLowerItem',
	// 	'armorItem',
	// 	'rightHandItem',
	// 	'leftHandItem',
	// 	'garmentItem',
	// 	'shoesItem',
	// 	'rightAccessoryItem',
	// 	'leftAccessoryItem',
	// ]

	const [modalIsOpen, setIsOpen] = React.useState(false)

	function openModal() {
		setIsOpen(true)
	}

	function closeModal() {
		setIsOpen(false)
	}

	useEffect(() => {
		changeEquipSets(
			item_combos.filter((combos) =>
				combos.Combos.find((combo) =>
					combo.Combo.every((comb) =>
						[
							inventory['Head_Top'].AegisName,
							inventory['Head_Top'].CardSlots[0].AegisName,
							inventory['Head_Mid'].AegisName,
							inventory['Head_Mid'].CardSlots[0].AegisName,
							inventory['Head_Low'].AegisName,
							inventory['Armor'].AegisName,
							inventory['Armor'].CardSlots[0].AegisName,
							inventory['Right_Hand'].AegisName,
							inventory['Right_Hand'].CardSlots[0].AegisName,
							inventory['Right_Hand'].CardSlots[1].AegisName,
							inventory['Right_Hand'].CardSlots[2].AegisName,
							inventory['Right_Hand'].CardSlots[3].AegisName,
							inventory['Left_Hand'].AegisName,
							inventory['Left_Hand'].CardSlots[0].AegisName,
							inventory['Left_Hand'].CardSlots[1].AegisName,
							inventory['Left_Hand'].CardSlots[2].AegisName,
							inventory['Left_Hand'].CardSlots[3].AegisName,
							inventory['Garment'].AegisName,
							inventory['Garment'].CardSlots[0].AegisName,
							inventory['Shoes'].AegisName,
							inventory['Shoes'].CardSlots[0].AegisName,
							inventory['Right_Accessory'].AegisName,
							inventory['Right_Accessory'].CardSlots[0].AegisName,
							inventory['Left_Accessory'].AegisName,
							inventory['Left_Accessory'].CardSlots[0].AegisName,
							inventory['Shadow_Weapon'].AegisName,
							inventory['Shadow_Shield'].AegisName,
							inventory['Shadow_Armor'].AegisName,
							inventory['Shadow_Shoes'].AegisName,
							inventory['Shadow_Right_Accessory'].AegisName,
							inventory['Shadow_Left_Accessory'].AegisName,
						].includes(comb),
					),
				),
			),
		)
		setEquip([
			inventory['Head_Top'],
			inventory['Head_Mid'],
			inventory['Head_Low'],
			inventory['Armor'],
			inventory['Right_Hand'],
			inventory['Left_Hand'],
			inventory['Garment'],
			inventory['Shoes'],
			inventory['Right_Accessory'],
			inventory['Left_Accessory'],
		])
		setShadowEquip([
			inventory['Shadow_Weapon'],
			inventory['Shadow_Shield'],
			inventory['Shadow_Armor'],
			inventory['Shadow_Shoes'],
			inventory['Shadow_Right_Accessory'],
			inventory['Shadow_Left_Accessory'],
		])

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [inventory, item_combos])

	// const handleClick = (value) => {
	// 	setIsShadowGear(value)
	// }

	return (
		<div className={'equipementTabModalMainContainer ' + props.className}>
			{/* browse the inventory */}
			{/* <input
				type='button'
				value='Equipment'
				onClick={() => handleClick(false)}
			/>
			<input
				type='button'
				value='Shadow gears'
				onClick={() => handleClick(true)}
			/> */}
			<div className='equipementTabModal'>
				<div
					className={
						'Gears '
						// + (isShadowGear ? 't_invisible' : '')
					}
				>
					{/* {console.log(equip)} */}
					{/* {itemDBEquipReady
					? Object.keys(equip).map((key) =>
							// console.log(key)
							displayInventory(
								props,
								equip,
								key,
								maxRefine,
								openModal,
								setCurrentLocation
							)
					  )
					: 'loading DB..'} */}
					{Object.keys(equip).map((key) =>
						// console.log(key)
						displayInventory(
							props,
							equip,
							key,
							maxRefine,
							openModal,
							setCurrentLocation,
						),
					)}
				</div>
				<div
					className={
						'ShadowGears '
						//  + (!isShadowGear ? 't_invisible' : '')
					}
				>
					{/* {itemDBEquipReady
					? Object.keys(shadowEquip).map((key) =>
							displayInventory(
								props,
								shadowEquip,
								key,
								maxRefine,
								openModal,
								setCurrentLocation
							)
					  )
					: 'loading DB..'} */}
					{Object.keys(shadowEquip).map((key) =>
						displayInventory(
							props,
							shadowEquip,
							key,
							maxRefine,
							openModal,
							setCurrentLocation,
						),
					)}
				</div>
				<EquipmentModal
					location={currentLocation}
					itemList={filterItems(item_db_equip, currentLocation, job)}
					modalIsOpen={modalIsOpen}
					closeModal={closeModal}
					setLastSelectedItem={props.setLastSelectedItem}
					lastSelectedItem={props.lastSelectedItem}
				/>
				{/* <div className='equipements'>
				<img
					src='./Images/Equipements/equipwin_bg.bmp'
					alt='equipement windows'
				/>
				{locationList.map((loc, index) =>
					displayInventory2(
						loc,
						locationSlotList[index],
						openModal,
						setCurrentLocation
					)
				)}
			</div> */}
			</div>
		</div>
	)
}

function displayInventory(
	props,
	equip,
	key,
	maxRefine,
	openModal,
	setCurrentLocation,
) {
	// console.log(maxRefine)
	return (
		<div className='horizontal' key={equip[key].Location}>
			<Cards Name={equip[key].Location}>
				{/* label for the invetory slot */}
				{/* <label
					htmlFor={equip[key].Location}
					onClick={() => {
						openModal()
						setCurrentLocation(equip[key].Location)
						// console.log(equip[key].Location)
					}}
				>
					{language[props.currentLanguage][equip[key].Location]}
				</label> */}
				{/* generate refine select and equip select for current inventory slot */}
				<EquipSelect
					id={equip[key].Location}
					Location={equip[key].Location}
					Refinable={equip[key].isRefinable}
					MaxRefine={maxRefine[equip[key].Location]}
					setLastSelectedItem={props.setLastSelectedItem}
				/>
				{/* generate card(s) or enchant(s) slot if available for this equipement */}
				{/* <div className='cardenchant'>
				{equip[key].CardSlots.map((cardSlot, index) =>
					cardSlot.Type === 'Card' ? (
						<CardSelect
							id={'card' + equip[key].Location}
							Location={equip[key].Location}
							Slot={index}
							key={
								equip[key].Location + 'Slot' + index
								// (inventory[key] + 1)
							}
							setLastSelectedItem={props.setLastSelectedItem}
						/>
					) : cardSlot.Type === 'Enchant' ? (
						<EnchantSelect
							id={'ench' + equip[key].Location + '1'}
							Location={equip[key].Location}
							setLastSelectedItem={props.setLastSelectedItem}
						/>
					) : null
				)}
			</div> */}
			</Cards>
		</div>
	)
}
// function displayInventory2(loc, className, openModal, setCurrentLocation) {
// 	return (
// 		<div
// 			className={className}
// 			onClick={(e) => {
// 				openModal()
// 				setCurrentLocation(loc)
// 			}}
// 			key={loc + 'test2'}
// 		/>
// 	)
// }
function filterItems(item_db_equip, Location, job) {
	let Location2 = Location
	if (Location === 'Right_Accessory' || Location === 'Left_Accessory')
		Location2 = 'Both_Accessory'
	if (Location === 'Right_Hand') Location2 = 'Both_Hand'
	let formatedBaseClassName = jobsID.getFormatedBaseClassName(job)
	let gender = ''
	if (
		formatedBaseClassName === 'Bard' ||
		formatedBaseClassName === 'Dancer'
	) {
		gender = formatedBaseClassName === 'Bard' ? 'Male' : 'Female'
		formatedBaseClassName = 'BardDancer'
	}
	if (formatedBaseClassName === 'Star_Gladiator')
		formatedBaseClassName = 'StarGladiator'
	if (formatedBaseClassName === 'Soul_Linker')
		formatedBaseClassName = 'SoulLinker'

	let filteredDB = item_db_equip.filter(
		(eq) =>
			(eq.Locations?.[Location] || eq.Locations?.[Location2]) &&
			(!eq.Jobs || eq.Jobs?.[formatedBaseClassName]) &&
			(!eq.Gender || eq.Gender === gender),
	)
	return filteredDB
}
export default EquipementTabModal
